import { createStore } from 'satcheljs';
import { IAccountViewState } from './schema/IAccountViewState';

export const getStore = createStore<IAccountViewState>('AccountState', {
  active: {},
  errors: {},
  enablePrivateMarketplace: false,
});
